import { EnumFinancialType } from "../enumerations/financial-type";
import { EnumParameterType } from "../enumerations/parameter-type";

export class FinancialParameter {
    id: number;
    type: EnumFinancialType;
    parameter: EnumParameterType;
    value: number;
    active: boolean;
}